import { Member } from '@features/members/models/member.model';
import { Organization } from '@features/organizations/models/organization.model';
import { MembersStateModel } from '@stores/members/members.model';
import { OrganizationsStateModel } from '@stores/organizations/organizations.model';

export function beforeSerializer(obj: unknown, key: string): unknown {
  if (key === 'MembersState') {
    const memState = obj as MembersStateModel;

    if (memState && memState.members) {
      const members = [];

      for (const member of memState.members) {
        const { updatedAt, mu, sigma, conservativeRating, publicDisplayname, organization, ...properties } = member.toJSON();
        members.push(properties);
      }

      return { ...memState, members: members };
    }
  }

  return obj;
}

export function afterDeserializer(obj: unknown, key: string): unknown {
  if (key === 'OrganizationsState') {
    const orgState = obj as OrganizationsStateModel;
    if (orgState.currentOrganization) {
      orgState.currentOrganization = Organization.fromStorage(orgState.currentOrganization);
    }
    orgState.organizations = orgState.organizations.map((org) => Organization.fromStorage(org));
    orgState.loading = false;

    // Stale caches may be missing the owner pointer; drop them so LoadUserOrganizations refetches
    if (orgState.organizations.some((org) => !org.owner)) {
      orgState.organizations = [];
      orgState.currentOrganization = undefined;
      orgState.lastUpdated = new Date(0);
    }

    return orgState;
  }

  if (key === 'MembersState') {
    const memState = obj as MembersStateModel;
    memState.members = memState.members.map((mem) => Member.fromStorage(mem));
    memState.loading = false;
    return memState;
  }

  return obj;
}
